import React from 'react';
import SettingsLegalDocument from '../SettingsLegalDocument';
import { PRIVACY_NOTICE_SECTIONS, PRIVACY_NOTICE_TITLE } from './privacyNoticeContent';

const PrivacyNotice = () => (
  <SettingsLegalDocument title={PRIVACY_NOTICE_TITLE} sections={PRIVACY_NOTICE_SECTIONS} />
);

export default PrivacyNotice;
